import { Box } from '@mui/system';
import React, { useMemo } from 'react';
import { Divider, Stack } from '@mui/material';
import CardEntry from './CardEntry';
import { theme } from '../../../theme';

function PhysicianCardArea(props) {
    const sortedDrafts = useMemo(() => {
        return props.drafts.slice().sort((a, b) => b.savings_opportunity - a.savings_opportunity);
    }, [props.drafts]);

    return (
        <Stack 
            direction='row' 
            width='100%' 
            backgroundColor={theme.palette.background.darkGray}
            borderTop='1px solid'
            borderColor={theme.palette.border.main}
            style={{
                '&:lastChild': {
                    borderBottomRightRadius: '8px',
                    borderBottomLeftRadius: '8px',
                }
            }}
        >
            <Box width='15%' />
            <Stack width='85%' divider={<Divider />}>
                { sortedDrafts.map((draft) => {
                    return <CardEntry 
                        key={draft.id} 
                        draft={draft} 
                        variant={props.variant} 
                        isTopDraft={props.topDrafts?.includes(draft)}
                    />
                })}
            </Stack>
        </Stack>
    );
}

export default PhysicianCardArea;
